import React, { useState } from 'react';
import {
    Box, Grid,
    Typography, TextField, Button,
    Stack, IconButton, List, ListItem, ListItemText,
    CircularProgress,
} from '@mui/material';
import { Link } from 'react-router-dom';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailIcon from '@mui/icons-material/Mail';
import CallIcon from '@mui/icons-material/Call';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import Logo from "../../images/logo/Logo.svg";
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { API_CONFIG } from '../../api/apiUrl';

const Footer = () => {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const isFooterFormValid = email && !emailError;

    const validateEmail = (value: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value) {
            return 'Email is required';
        } else if (!emailRegex.test(value)) {
            return 'Please enter a valid email';
        }
        return '';
    };

    const handleEmailChange = (e: any) => {
        const value = e.target.value;
        setEmail(value);
        setEmailError(validateEmail(value));
    };
    const handleSubscribe = async (e: any) => {
        e.preventDefault();
        const error = validateEmail(email);
        if (error) {
            toast.error(error);
            setEmailError(error);
            return;
        }
        setIsLoading(true);
        try {
            const response = await axios.post(API_CONFIG.SUBSCRIBE_EMAILS, { email }, {
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.status === 200 || response.status === 201) {
                setEmail('');
                setEmailError('');
                toast.success('Thank you for subscribing! Stay tuned for updates!');
            }
        } catch (error: any) {

            if (error.response?.data?.detail?.includes("Duplicate entry")) {
                toast.error('This email is already subscribed. Please use a different email.');
            } else {
                toast.error('Failed to subscribe. Please try again later.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box sx={{ pt: { xs: 5, md: 7 }, pb: { xs: 2, md: 3 }, px: { xs: 2, md: 5 } }}>
            <Toaster position="top-right" />
            <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                    <img src={Logo} alt='logo' />
                    <Typography sx={{ mb: 2, color: '#161717', fontSize: '17px', fontFamily: "League Spartan", fontWeight: 400 }}>
                    Meegloo is a modern tech platform that is organizing the unorganized sector of residential home construction. Leveraging technology, we map customer requirements to empanelled service providers who are best for the job. We are making the whole process seamless from booking to home handover very transparent, easy to track in real time and at the same time providing you with quality assurance so that you don’t have to run around the sites and contractors to get your home made.

                    </Typography>

                </Grid>

                <Grid item xs={6} md={2}>
                    <Typography sx={{ mb: 2, color: '#89652A', fontSize: '22px', fontWeight: 500, fontFamily: "League Spartan" }}> </Typography>
                    <List sx={{ p: 0 }}>
                        {services.map((service) => (
                            <ListItem key={service} sx={{ p: 0 }}>
                                <ListItemText primary={service} primaryTypographyProps={{ color: '#161717', fontSize: '17px', fontWeight: 400, fontFamily: "League Spartan" }} />
                            </ListItem>
                        ))}
                    </List>
                </Grid>

                {/* <Grid item xs={6} md={3}>
                    <Typography sx={{ mb: 2, color: '#89652A', fontSize: '22px', fontWeight: 500, fontFamily: "League Spartan" }}> </Typography>
                    <List sx={{ p: 0 }}>
                        {company.map((item) => (
                            <ListItem key={item.label} sx={{ p: 0 }}>
                                <ListItemText
                                    primary={
                                        item.url.startsWith('http') ? (
                                            <a href={item.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#161717' }}>
                                                {item.label}
                                            </a>
                                        ) : (
                                            <Link to={item.url} style={{ textDecoration: 'none', color: '#161717' }}>
                                                {item.label}
                                            </Link>
                                        )
                                    }
                                    primaryTypographyProps={{ fontSize: '17px', fontWeight: 400, fontFamily: "League Spartan" }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Grid> */}

                <Grid item xs={12} md={4}>
                    <Typography sx={{ mb: 2, color: '#89652A', fontSize: '22px', fontFamily: "League Spartan", fontWeight: 500 }}>Join Our Newsletter</Typography>
                    <Typography sx={{ fontSize: '20px', fontFamily: "League Spartan", fontWeight: 400 }}>Your Email</Typography>
                    <Box component="form" onSubmit={handleSubscribe} sx={{ display: 'flex', mb: 2 }}>
                        <TextField
                            fullWidth
                            placeholder="Enter Your Email"
                            variant="outlined"
                            size="small"
                            value={email}
                            onChange={handleEmailChange}
                            error={!!emailError}
                            helperText={emailError}
                            InputProps={{
                                startAdornment: <EmailIcon sx={{ mr: 1, color: '#89652A' }} />
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                    borderColor: '#89652A',
                                    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#B69D74', borderWidth: '1.5px' },
                                    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#89652A' },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#89652A', borderWidth: '2px' },
                                },
                                '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#B69D74',
                                },
                                '& .MuiInputBase-input': { padding: '14px 14px' },
                                '& .MuiFormHelperText-root': {
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    margin: 0,
                                    fontSize: '12px',
                                    color: 'error.main'
                                }
                            }}
                        />
                        <Button
                            type="submit"
                            sx={{
                                ml: 2,
                                bgcolor: '#89652A',
                                fontSize: '20px',
                                fontWeight: 600,
                                padding: "2px 25px",
                                fontFamily: "League Spartan",
                                textTransform: 'capitalize',
                                borderRadius: '6px',
                                color: 'white',
                                '&:hover': { bgcolor: '#6b4e20' },
                                '&:disabled': { bgcolor: '#a88b5e' }
                            }}
                            disabled={!isFooterFormValid || isLoading}
                        >
                            {isLoading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Subscribe'}
                        </Button>
                    </Box>

                    {/* <Stack direction="row" spacing={1}>
                        {socialButtons.map((btn) => (
                            <IconButton
                                key={btn.label}
                                component="a"
                                href={btn.url}
                                target="_blank"
                                sx={{ bgcolor: '#89652A', fontFamily: "League Spartan", fontSize: '16px', fontWeight: 700, height: '40px', width: '40px', color: 'white', '&:hover': { bgcolor: '#89652A' } }}
                            >
                                {btn.icon}
                            </IconButton>
                        ))}
                    </Stack> */}
                </Grid>
            </Grid>

            <Box sx={{ mt: 4, pt: 4, borderTop: '1px solid #B69D74', display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}>
                    <Link to="/privacy-policy" style={{ textDecoration: 'none', color: '#161717', fontSize: '20px', fontFamily: "League Spartan", fontWeight: 400 }}>
                        Privacy Policy
                    </Link>
                </Box>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} sx={{ color: '#161717', fontSize: '20px', fontWeight: 400 }}>
                    {/* <Stack direction="row" spacing={1} alignItems="center">
                        <LocationOnIcon sx={{ color: "#89652A", fontFamily: "League Spartan" }} />
                        <Typography sx={{ fontFamily: "League Spartan" }}>123 Desi Lane, New Delhi, India 110001</Typography>
                    </Stack> */}
                    <Stack direction="row" spacing={1} alignItems="center">
                        <MailIcon sx={{ color: "#89652A" }} />
                        <Typography sx={{ fontFamily: "League Spartan" }}>info@meegloo.com</Typography>
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <CallIcon sx={{ color: "#89652A" }} />
                        <Typography sx={{ fontFamily: "League Spartan" }}>+91 8130664669</Typography>
                    </Stack>
                </Stack>
            </Box>

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', width: '100%' }}>
                <Typography sx={{ color: '#161717', fontSize: '18px', fontFamily: "League Spartan", fontWeight: 400, textAlign: 'center' }}>
                    © {new Date().getFullYear()} Meegloo. All rights reserved.
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;

const services = [
    '',

];
